export default {"src":"/_next/static/media/lock.a2e71ce1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};